import { createProxies } from "./proxies";

interface InteropExportsMethods {
  CopyLogs: () => string;
}

export interface InteropExports {
  Interop: InteropExportsMethods;
}

export const {
  setup,
  copyLogs,
} = createProxies<InteropExportsMethods>([
  "CopyLogs",
]);
